import type { LocalizedDict } from '../index'

export type SampleAdoptCardStrings = {
  addedToCatalog: string
  inventorySuffix: string
  addFailed: string
  inCatalog: string
  since: (date: string) => string
  openProduct: string
  addToCatalog: string
  variationOfExisting: string
  newProduct: string
  lookingForSimilar: string
  noSimilar: string
  skuCount: (n: number) => string
  match: (pct: number) => string
  multiVariantHint: string
  newAxisValue: (axis: string) => string
  multipleParents: string
  productTitle: string
  category: string
  ecosystem: string
  select: string
  firstAxis: string
  axisPlaceholder: string
  value: string
  valuePlaceholder: string
  skuCode: string
  addToInventory: string
  warehouse: string
}

export const sampleAdoptCardI18n: LocalizedDict<SampleAdoptCardStrings> = {
  en: {
    addedToCatalog: 'Added to catalog',
    inventorySuffix: ' (+inventory)',
    addFailed: 'Could not add to catalog',
    inCatalog: 'In catalog',
    since: (date) => `since ${date}`,
    openProduct: 'Open product',
    addToCatalog: 'Add to catalog',
    variationOfExisting: 'Variation of existing',
    newProduct: 'New product',
    lookingForSimilar: 'Looking for similar products…',
    noSimilar: 'No similar product found — switch to “New product”.',
    skuCount: (n) => `${n} SKU${n === 1 ? '' : 's'}`,
    match: (pct) => ` · match ${pct}%`,
    multiVariantHint: '— multi-variant product; add the variation from the product page',
    newAxisValue: (axis) => `New ${axis.toLowerCase()} value`,
    multipleParents:
      'This product has multiple variant parents — the quick adopt only supports single-parent products. Use “New product” or the product page instead.',
    productTitle: 'Product title',
    category: 'Category',
    ecosystem: 'Fulfillment ecosystem',
    select: 'Select…',
    firstAxis: 'First variation axis',
    axisPlaceholder: 'e.g. Color',
    value: 'Value',
    valuePlaceholder: 'e.g. Brown',
    skuCode: 'SKU code',
    addToInventory: 'Add the sample to inventory',
    warehouse: 'Warehouse…',
  },
  tr: {
    addedToCatalog: 'Kataloğa eklendi',
    inventorySuffix: ' (+envanter)',
    addFailed: 'Kataloğa eklenemedi',
    inCatalog: 'Katalogda',
    since: (date) => `${date} tarihinden beri`,
    openProduct: 'Ürünü aç',
    addToCatalog: 'Kataloğa ekle',
    variationOfExisting: 'Mevcut ürünün varyasyonu',
    newProduct: 'Yeni ürün',
    lookingForSimilar: 'Benzer ürünler aranıyor…',
    noSimilar: 'Benzer ürün bulunamadı — “Yeni ürün”e geç.',
    skuCount: (n) => `${n} SKU`,
    match: (pct) => ` · %${pct} eşleşme`,
    multiVariantHint: '— çok varyantlı ürün; varyasyonu ürün sayfasından ekle',
    newAxisValue: (axis) => `Yeni ${axis.toLocaleLowerCase('tr')} değeri`,
    multipleParents:
      'Bu ürünün birden çok varyant ana ürünü var — hızlı ekleme yalnızca tek ana ürünlü ürünlerde çalışır. “Yeni ürün”ü ya da ürün sayfasını kullan.',
    productTitle: 'Ürün başlığı',
    category: 'Kategori',
    ecosystem: 'Karşılama ekosistemi',
    select: 'Seç…',
    firstAxis: 'İlk varyasyon ekseni',
    axisPlaceholder: 'ör. Renk',
    value: 'Değer',
    valuePlaceholder: 'ör. Kahverengi',
    skuCode: 'SKU kodu',
    addToInventory: 'Numuneyi envantere ekle',
    warehouse: 'Depo…',
  },
}
